import AppBar from "@/components/bars/nav/AppBar";
import { useLayoutEffect } from "react";
import SideBar from "@/components/bars/nav/SideBar";

const SideNavLayout = ({ children, fullScreen = false, appBar = true }) => {
  console.log('SideNavLayout rendered with fullScreen:', fullScreen, 'and appBar:', appBar);

  useLayoutEffect(() => {
    if (fullScreen) {
      document.body.setAttribute("data-full-screen", "true");
    } else {
      document.body.setAttribute("data-full-screen", "false");
    }
  }, [fullScreen]);

  return (
    <div className="page" data-side-nav="true">
      {appBar && !fullScreen && <AppBar />}
      {!fullScreen && <SideBar />}
      <div className={`app-content ${(!appBar || fullScreen) && "mt-0"}`}>
        {children}
      </div>
    </div>
  );
};

SideNavLayout.propTypes = {};

export default SideNavLayout;
